import { render } from "./InternalServerError.vue?vue&type=template&id=6d2202bc"
import script from "./InternalServerError.vue?vue&type=script&lang=js"
export * from "./InternalServerError.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__